import { useCallback, useEffect } from 'react';
//
import { useAuthContext, useRouter, useSearchParams } from 'hooks';

// ----------------------------------------------------------------------

type Props = {
    children: React.ReactNode;
};

export default function GuestGuard({ children }: Props) {
    const router = useRouter();

    const searchParams = useSearchParams();

    const returnTo = searchParams.get('returnTo') || '/admin/users';

    const { authenticated } = useAuthContext();

    const check = useCallback(() => {
        if (authenticated) {
            router.replace(returnTo);
        }
    }, [authenticated, returnTo, router]);

    useEffect(() => {
        check();
    }, [check]);

    return <>{children}</>;
}
